<script lang="ts">
import { defineComponent } from 'vue';
import { formatCurrency, formatMoney } from '@/utils/format';
import Decimal from 'decimal.js-light';
import {
  calculateCashOutMultiplier,
  getIsBetCasheableColoredFlag,
  isBetCasheable,
} from '@/components/calculator/helper';

export default defineComponent({
  name: 'row-possible-cashout',
  computed: {
    isEnabled() {
      for (const b of this.stake.bets) {
        console.log(isBetCasheable(b), b);
      }
      return this.stake.bets.every((b) => isBetCasheable(b) || b.selection.ResultStatus);
    },
    flags() {
      const acc: string[] = [];

      for (const bet of this.stake.bets) {
        acc.push(getIsBetCasheableColoredFlag(bet));
      }

      return acc.join('');
    },
    cashOutAmount() {
      const multiplier = calculateCashOutMultiplier(this.stake.bets);
      const amount = multiplier.mul(this.stake.stakeAmount);

      return amount.lte(this.stake.stakeAmount)
        ? amount.mul(0.9).toNumber()
        : amount.mul(0.85).toNumber();
    },
    cashOutAmountUsd() {
      return new Decimal(this.cashOutAmount)
        .mul(this.stake.vendorStakeAmount)
        .div(this.stake.stakeAmount)
        .toNumber();
    },
  },
  methods: { formatMoney, formatCurrency },
  props: ['stake'],
});
</script>

<template>
  <span>Возможный кешаут</span>
  <template v-if="isEnabled">
    <span class="col-span-2">
      {{ formatMoney(cashOutAmount) }}
      {{ formatCurrency(cashOutAmount, stake.currency) }}

      <span class="text-gray-500">
        {{ formatMoney(cashOutAmountUsd, 2, false) }}
        {{ formatCurrency(cashOutAmountUsd, stake.vendorCurrency) }}
      </span>
    </span>
  </template>
  <template v-else>
    <span class="italic"> Недоступен </span>
    <span v-html="flags" />
  </template>
</template>

<style scoped lang="scss"></style>
